import { formUniqueId, versionLabel } from '@/lib/versioning'

/**
 * What the Form Builder's version indicator says (z8nrz7dmb1 AC1).
 *
 * - A form never saved has no version at all: `Not yet saved` (AC1.6).
 * - A saved form whose version could not be read: `Version unavailable`
 *   (AC1.10) — never a blank, and never a guess.
 * - Otherwise its Unique ID — the same `FRM-<code>-V<n>` the Form Definitions
 *   table prints (AC1.2), from the same helper, so the two cannot disagree.
 */
export type FormVersionIndicatorState =
  | { kind: 'unsaved'; text: 'Not yet saved' }
  | { kind: 'unavailable'; text: 'Version unavailable' }
  | { kind: 'version'; text: string; active: boolean }

export function formVersionIndicatorState(input: {
  definitionId: string | undefined
  version: number | null | undefined
  familyId: string | null | undefined
  active: boolean | null | undefined
}): FormVersionIndicatorState {
  if (!input.definitionId) return { kind: 'unsaved', text: 'Not yet saved' }
  if (input.version == null || input.active == null) return { kind: 'unavailable', text: 'Version unavailable' }
  return {
    kind: 'version',
    text: formUniqueId({ id: input.definitionId, familyId: input.familyId ?? undefined, version: input.version }),
    active: input.active,
  }
}

/** How a version reads in the list: its user-facing label, else `V<n>`. */
export function familyVersionLabel(v: { version: number; versionName?: string | null }): string {
  return v.versionName?.trim() || versionLabel(v.version)
}
